import React from "react";

import { Box, Grid, Typography } from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";

import SelectBox from "../../../common/SelectBox/SelectBox";
import LinkButton from "../../..//common/LinkButton/LinkButton";
import MultiSelectBox from "../../../common/MultiSelectBox/MultiSelectBox";
import SwitchButton from "../../../common/SwitchButton/SwitchButton";
import TimePicker from "../../../common/TimePicker/TimePicker";

import { ReactComponent as DeleteIcon } from "../../../assets/svg/DeleteIcon.svg";

import { DEFAULT_RULE_CONFIG, MaximumPromiseRuleValuesInterface, MaximumTimeConfigItem, RULE_ENGINE_TEXT_CONSTANT, calculateAvailableDaysForSelection, getDefaultOrFixedTimeMinutes } from "../../RuleEngineUtils";
import { ChangeConfigOtion } from "../ServiceRuleEngineUtils";
import { DEFAULT_TIME_HOURS } from "../ServiceRuleEngine";
import { HEADER_NAME_CONSTANT } from "../../CurrentConfiguration/CurrentConfigConstant";
import { isArrayValid, isUndefined } from "../../../../utils/DataUtils";

interface RenderMaximumPromiseTypeConfigurationInterface {
  classes: any;
  config: DEFAULT_RULE_CONFIG;
  onMaxTimeIsSameAsEarlierChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleMaxTimeConfigEdit: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isAddMaximumDeliveryPromiseOtherDaysButtonDisabled: () => boolean;
  onAddMaximumDeliveryPromiseOtherDays: () => void;
  onMaxPromiseConfigDaysChange: (name: string, maximumConfigObjIndex: number, event: React.ChangeEvent<HTMLInputElement>) => void;
  onMaxConfigChange: (name: string, maximumConfigObjIndex: number, timeConfigObjIndex: number, event: React.ChangeEvent<HTMLInputElement> | any) => void;
  handleAddMaximumConfigSlotButton: (maximumConfigObjIndex: number) => void;
  handleRemoveMaximumConfigSlotButton: (maximumConfigObjIndex: number, timeConfigObjIndex: number) => void;
  handleRemoveMaximumPromiseOtherDays: (maximumConfigObjIndex: number) => void;
  handleMaxPromiseTimeConfigEdit: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const RenderMaximumPromiseTypeConfiguration = (props: RenderMaximumPromiseTypeConfigurationInterface) => {
  const {
    classes,
    config,
    onMaxTimeIsSameAsEarlierChange,
    handleMaxTimeConfigEdit,
    isAddMaximumDeliveryPromiseOtherDaysButtonDisabled,
    onAddMaximumDeliveryPromiseOtherDays,
    onMaxPromiseConfigDaysChange,
    onMaxConfigChange,
    handleAddMaximumConfigSlotButton,
    handleRemoveMaximumConfigSlotButton,
    handleRemoveMaximumPromiseOtherDays,
    handleMaxPromiseTimeConfigEdit,
  } = props;

  const showAddOtherDaysSpan = (maximumConfigObjIndex: number) => maximumConfigObjIndex === 0;
  const showAddIcon = (timeConfigObjIndex: number) => timeConfigObjIndex === 0;

  return (
    <Grid container className={classes.ruleContainer} spacing={0}>
      <Grid item xs={9}>
        <Grid container spacing={1}>
          <Grid item xs={5} className={classes.ruleLabel}>
            {`${HEADER_NAME_CONSTANT.MAXIMUM_PROMISE_TIME}`}
          </Grid>
          {!config.promiseConfig.maxTimeSameAsEarlier && (
            <>
              <Grid item xs={6} className={classes.dFlexEnd}>
                {`${HEADER_NAME_CONSTANT.USE_THIS_VALUE_IN_CALCULATION}`}
              </Grid>
              <Grid item xs={1}>
                <SwitchButton
                  className={config.isEditMode && !config.promiseConfig.enableMaxTimeEdit ? classes.disableSwitch : ""}
                  size="small"
                  checked={config.promiseConfig.maxActive}
                  disabled={config.isEditMode && !config.promiseConfig.enableMaxTimeEdit}
                  handleChange={handleMaxPromiseTimeConfigEdit}
                  changeExisting={config.promiseConfig.enableMaxTimeEdit}
                  leftLabel={undefined}
                  rightLabel={undefined}
                />
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
      <ChangeConfigOtion
        config={config}
        checked={config.promiseConfig.maxTimeSameAsEarlier}
        classes={classes}
        xsValue={4}
        checkChangeHandler={onMaxTimeIsSameAsEarlierChange}
        changeExisting={config.promiseConfig.enableMaxTimeEdit}
        onConfigEdit={handleMaxTimeConfigEdit}
      />

      {config.promiseConfig.maxActive && (
        <>
          {isArrayValid(config.promiseConfig.maximumPromiseRuleValues) &&
            config.promiseConfig.maximumPromiseRuleValues.map((maximumConfigObj: MaximumPromiseRuleValuesInterface, maximumConfigObjIndex: number) => (
              <Box className={classes.ruleContainerBoxStyle}>
                <Grid item xs={12} className={classes.ruleEditingDivStyle} key={`${maximumConfigObjIndex}-maximum-Config-Obj-Index`}>
                  <Grid container spacing={1} justifyContent="space-between">
                    <Grid item xs={6}>
                      <MultiSelectBox
                        label={`${RULE_ENGINE_TEXT_CONSTANT.DAYS}`}
                        menuitems={calculateAvailableDaysForSelection(maximumConfigObjIndex, config.promiseConfig.maximumPromiseRuleValues)}
                        value={maximumConfigObj.configuredDays}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onMaxPromiseConfigDaysChange(RULE_ENGINE_TEXT_CONSTANT.CONFIGURED_DAYS, maximumConfigObjIndex, e)}
                        disabled={config.isEditMode && !config.promiseConfig.enableMaxTimeEdit}
                        doNotShowAllInAllSelected={true}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      {showAddOtherDaysSpan(maximumConfigObjIndex) ? (
                        config.promiseConfig.enableMaxTimeEdit &&
                        !isAddMaximumDeliveryPromiseOtherDaysButtonDisabled() && (
                          <Grid container spacing={1} justifyContent="flex-end">
                            <Grid item xs={12} className={classes.addOtherDays}>
                              <LinkButton buttonLabel={`${HEADER_NAME_CONSTANT.ADD_OTHER_DAYS}`} disabled={isAddMaximumDeliveryPromiseOtherDaysButtonDisabled()} onClick={onAddMaximumDeliveryPromiseOtherDays} />
                            </Grid>
                          </Grid>
                        )
                      ) : (
                        <Grid container spacing={1} justifyContent="flex-end">
                          <Grid item xs={12} className={classes.addOtherDays}>
                            {config.promiseConfig.enableMaxTimeEdit && <DeleteIcon className={classes.deleteIconStyle} onClick={() => handleRemoveMaximumPromiseOtherDays(maximumConfigObjIndex)} />}
                          </Grid>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>

                  {!isUndefined(maximumConfigObj?.timeConfig) && isArrayValid(maximumConfigObj.timeConfig) && (
                    <>
                      <Grid container spacing={1}>
                        <Grid item xs={2}>
                          <Typography>{`${RULE_ENGINE_TEXT_CONSTANT.START_TIME}`}</Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <Typography>{`${RULE_ENGINE_TEXT_CONSTANT.END_TIME}`}</Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <Typography>{`${RULE_ENGINE_TEXT_CONSTANT.MAX_TIME_HOUR}`}</Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <Typography>{`${RULE_ENGINE_TEXT_CONSTANT.MAX_TIME_MINUTES}`}</Typography>
                        </Grid>
                      </Grid>
                      <Grid container spacing={1}>
                        {maximumConfigObj.timeConfig.map((timeConfigObj: MaximumTimeConfigItem, timeConfigObjIndex: number) => (
                          <>
                            <Grid item xs={2}>
                              <TimePicker
                                value={timeConfigObj.startTime}
                                handleChange={(date: any) => onMaxConfigChange(RULE_ENGINE_TEXT_CONSTANT.FIELD_LABEL_START_TIME, maximumConfigObjIndex, timeConfigObjIndex, date)}
                                fieldLabel={""}
                                className={undefined}
                                timerProps={undefined}
                                disabled={!config.promiseConfig.enableMaxTimeEdit}

                              />
                            </Grid>
                            <Grid item xs={2}>
                              <TimePicker
                                value={timeConfigObj.endTime}
                                handleChange={(date: any) => onMaxConfigChange(RULE_ENGINE_TEXT_CONSTANT.FIELD_LABEL_END_TIME, maximumConfigObjIndex, timeConfigObjIndex, date)}
                                fieldLabel={""}
                                className={undefined}
                                timerProps={undefined}
                                disabled={!config.promiseConfig.enableMaxTimeEdit}

                              />
                            </Grid>
                            <Grid item xs={2}>
                              <SelectBox
                                fieldLabel=""
                                menuItems={DEFAULT_TIME_HOURS}
                                value={timeConfigObj.maxTimeHour}
                                handleChange={(event: React.ChangeEvent<HTMLInputElement>) => onMaxConfigChange(RULE_ENGINE_TEXT_CONSTANT.FIELD_LABEL_MAX_TIME_HOUR, maximumConfigObjIndex, timeConfigObjIndex, event)}
                                disabled={!config.promiseConfig.enableMaxTimeEdit}
                              />
                            </Grid>
                            <Grid item xs={2}>
                              <SelectBox
                                fieldLabel=""
                                menuItems={getDefaultOrFixedTimeMinutes(timeConfigObj.maxTimeHour)}
                                value={timeConfigObj.maxTimeMinutes}
                                handleChange={(event: React.ChangeEvent<HTMLInputElement>) => onMaxConfigChange(RULE_ENGINE_TEXT_CONSTANT.FIELD_LABEL_MAX_TIME_MINUTES, maximumConfigObjIndex, timeConfigObjIndex, event)}
                                disabled={!config.promiseConfig.enableMaxTimeEdit}
                              />
                            </Grid>
                            <Grid item xs={4} className={classes.addCircleGridStyle}>
                              {config.promiseConfig.enableMaxTimeEdit && showAddIcon(timeConfigObjIndex) ? (
                                <AddCircleIcon className={classes.addCircleStyle} onClick={() => handleAddMaximumConfigSlotButton(maximumConfigObjIndex)} />
                              ) : (
                                config.promiseConfig.enableMaxTimeEdit && <DeleteIcon className={classes.deleteIconStyle} onClick={() => handleRemoveMaximumConfigSlotButton(maximumConfigObjIndex, timeConfigObjIndex)} />
                              )}
                            </Grid></>
                        ))}
                      </Grid>
                    </>
                  )}

                </Grid>
              </Box>
            ))}
        </>
      )}
    </Grid>
  );
};

export default React.memo(RenderMaximumPromiseTypeConfiguration);
